import { computed, defineComponent, reactive } from 'vue';
import { useStore } from 'vuex';
import AddressInfo from '@hems/user/src/containers/popup/homeinfo/installation/AddressInfo.vue';
import InstallerInfo from '@hems/user/src/containers/popup/homeinfo/installation/InstallerInfo.vue';
import ProductInfo from '@hems/user/src/containers/popup/homeinfo/installation/ProductInfo.vue';
export default defineComponent({
    name: 'InstallationInfo',
    components: {
        ProductInfo,
        InstallerInfo,
        AddressInfo,
    },
    setup() {
        const store = useStore();
        const state = reactive({
            tabName: 'product',
        });
        const genType = computed(() => store.state.device.gen_type);
        function onClickTab(tabName) {
            state.tabName = tabName;
        }
        return {
            state,
            onClickTab,
            genType,
        };
    },
});
